module.exports = __webpack_public_path__ + "img/TymeBank.c79fdee7.png";